import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { ToastrService } from 'ngx-toastr';
import { AdjuntoService } from 'src/app/services/adjunto.service';
import { AuthService } from 'src/app/services/auth.service';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-becode',
  templateUrl: './becode.component.html',
  styleUrls: []
})
export class BecodeComponent implements OnInit {

  loadingInitialData: boolean = true;
  progress: boolean = false;

  BecodeForm: FormGroup;
  validarionsRut: any;

  user: any = null;
  docs: any = [];

  constructor(
    private fb: FormBuilder,
    private rutValidator: RutValidator,
    private auths: AuthService,
    private contactservice: ContactService,
    private docService: AdjuntoService,
    public alerts: ToastrService,
  ) {
    this.validarionsRut = rutValidator;
    this.BecodeForm = this.fb.group({
      Rut: ['', [Validators.required, Validators.maxLength(50), this.validarionsRut, Validators.minLength(3)]], //OK -
      Email: ['', [Validators.required, Validators.maxLength(60), Validators.minLength(3)]], //OK -
      Nombre: ['', [Validators.required, Validators.maxLength(60), Validators.minLength(3)]], //OK -
      Sede: ['', Validators.required], //OK -
      Becode: ['', Validators.required], //OK -
    });
  }

  ngOnInit(): void {
    this.loadInitialData();
  }

  /********* LOADS *********/
  async loadInitialData() {
    // Datos usuario conectado
    await this.loadUserData();
    await this.loadDocumentosRequeridos();
    this.loadingInitialData = false;
  }

  async loadUserData() {
    const userToken: any = this.auths.GetUserToken();
    if (userToken !== null) {
      this.user = await this.contactservice.GetContactFull(userToken.primarysid, null).toPromise();
      this.user.fullName = `${this.user.Nombre} ${this.user.Nombre2} ${this.user.ApellidoP} ${this.user.ApellidoM}`;
    }
  }

  async loadDocumentosRequeridos() {
    const result: any = await this.docService.GetRequeridos("UST", 2021, "NEM").toPromise();
    if (result.status === 1)
      this.docs = result.data;
    console.log('[BECODE] loadDocumentosRequeridos', result);
  }
  /********* LOADS *********/

}
